import React from "react";
import logo from "./logo.svg";
import "./App.css";
import MyRouter from "../src/routers/index";

function App() {
  return (
    <div className="text-base bg-white  dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
